import { PathRouter } from './model/typed-router.model';

export const urlStartWith = (url: string, path: PathRouter[]): boolean => url.startsWith('/' + path.join('/'));
